export default __webpack_public_path__ + "static/media/scansFull.12a33421.png";